import { formatDateToCustomString } from "../../utils/utils";

const ConfirmPopup = ({
  handleClick,
  isOpen,
  togglePopup,
  nextBillingTime,
}) => {
  const handleConfirmClick = () => {
    handleClick();
    togglePopup();
  };
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div
        className="bg-black opacity-50 absolute inset-0"
        onClick={togglePopup}
      ></div>
      <div className="bg-white p-6 rounded shadow-lg z-10">
        <h2 className="text-lg font-semibold mb-4">
          Are you sure you want to cancel your subscription?
        </h2>
        <p>
          Your plan will stay active until{" "}
          {formatDateToCustomString(nextBillingTime)}, and will not renew after
          that.
        </p>
        <div className="flex justify-end space-x-2 mt-5">
          <button
            className="bg-green-500 text-white px-4 py-2 rounded"
            onClick={handleConfirmClick}
          >
            Confirm
          </button>
          <button
            className="bg-gray-300 text-gray-700 px-4 py-2 rounded"
            onClick={togglePopup}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmPopup;
